import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import FormBuilder from "../../../../components/forms/formBuilder";

class FormBuilderModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            historyOpen: false,
            hasPendingEdits: false
        };
    }

    handleHistoryStateChange = (historyOpen, hasPendingEdits) => {
        this.setState({ historyOpen, hasPendingEdits });
    };

    render() {
        const { isOpen, toggle, editedForm, saveForm, editing, cancelEdit } = this.props;
        const { historyOpen, hasPendingEdits } = this.state;
        const canSave = editing && !historyOpen;
        const saveButtonText = (editing && historyOpen) ? 'Changes Pending' : 'Save';

        return <Modal isOpen={isOpen} toggle={toggle} className="fullscreen formBuilderFullscreenModal">
            <div className='modalHeader ph-20 formBuilderStickyHeader'>
                <div className="headerContainer formBuilderHeaderContainer">

                    <div >
                        <h2>Form Builder</h2>
                        <h3>{editedForm.name}</h3>
                    </div>
                    <div className="flex">

                        <button className="neu mr-15 " onClick={() => {
                            if (editing) {
                                if (window.confirm('Are you sure you want to discard your changes?')) {
                                    cancelEdit();
                                }
                            } else {
                                toggle();
                            }
                        }}>{!historyOpen && editing ? "Discard Changes" : "Close"}</button>
                        <button className={`neu  ${!canSave ? 'disabled' : 'prim'}`}
                            onClick={saveForm}>{saveButtonText}</button>
                    </div>
                </div>
            </div>
            <ModalBody className="modalBody formBuilderModalBody">
                <FormBuilder {...this.props} onHistoryStateChange={this.handleHistoryStateChange} />
            </ModalBody>
        </Modal>
    }
}

export default FormBuilderModal;